import React from 'react';

export interface CampanaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CampanaIcon: React.FC<CampanaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.766 22.502a2.083 2.083 0 0 1-3.604 0M19.214 8.96a6.25 6.25 0 0 0-12.5 0c0 7.292-3.125 9.375-3.125 9.375h18.75s-3.125-2.083-3.125-9.375"/>
    </svg>
  );
};

export default CampanaIcon;
